import React, { useState } from "react";
import styled from "@emotion/styled";
import { useMedia } from "react-use";
import { DSButton } from "@hundred5/design-system";
import { device } from "@/styles/breakpoints";
import {
  JobOfferWizardModal,
  useJobOfferEnableProgress,
} from "@/features/job-offer";

export function JobOfferBanner() {
  const isTablet = useMedia(device.tablet);
  const { jobOffersEnabled, loading } = useJobOfferEnableProgress();
  const [openWizardModal, setOpenWizardModal] = useState(false);

  if (jobOffersEnabled && !loading) {
    return null;
  }

  return (
    <>
      <JobOfferBannerContainer>
        <Title>Complete your profile</Title>
        <Description>
          Add more details to create a profile on Toggl Hire.
        </Description>
        <Action>
          <DSButton
            variant="secondary"
            size={isTablet ? "small" : "big"}
            onClick={() => setOpenWizardModal(true)}
          >
            Create profile
          </DSButton>
        </Action>
      </JobOfferBannerContainer>

      <JobOfferWizardModal
        isOpen={openWizardModal}
        onClose={() => setOpenWizardModal(false)}
      />
    </>
  );
}

const JobOfferBannerContainer = styled.div`
  padding: 16px;
  margin-bottom: 24px;
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.white};
  display: grid;
  grid-template-areas: "title action" "description action";
  grid-auto-columns: minmax(0, 1fr) min-content;
  grid-column-gap: 32px;
  grid-row-gap: 4px;
  align-items: center;

  @media ${device.tablet} {
    grid-template-areas: "title" "description" "action";
    grid-column-gap: 16px;
    grid-row-gap: 2px;
  }
`;

const Title = styled.div`
  grid-area: title;
  align-self: end;
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.typography.colorPrimary};

  @media ${device.tablet} {
    font-size: 14px;
  }
`;

const Description = styled.div`
  grid-area: description;
  align-self: start;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.typography.colorSecondary};

  @media ${device.tablet} {
    font-size: 12px;
  }
`;

const Action = styled.div`
  grid-area: action;

  @media ${device.tablet} {
    margin-top: 6px;
  }
`;
